/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CustomerNote
 */
export interface CustomerNote {
    /**
     * 
     * @type {number}
     * @memberof CustomerNote
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerNote
     */
    customerId?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerNote
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerNote
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomerNote
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the CustomerNote interface.
 */
export function instanceOfCustomerNote(value: object): boolean {
    return true;
}

export function CustomerNoteFromJSON(json: any): CustomerNote {
    return CustomerNoteFromJSONTyped(json, false);
}

export function CustomerNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerNote {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'text': json['text'] == null ? undefined : json['text'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function CustomerNoteToJSON(value?: CustomerNote | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'contactId': value['contactId'],
        'text': value['text'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

